import { RatingStarsOnlyStars } from "@/components/RatingStars";
import {
  createProductReview,
  createQuestion,
  uploadReviewImage,
} from "@/requests/product";
import {
  setGlobalPopupElement,
  setIsUserReviewed,
} from "@/store/features/globalSlice";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { toastMe } from "@/utils";
import { getS3ImageUrl } from "@/utils/routes";
import { Rating, Textarea } from "@mantine/core";
import Image from "next/image";
import { useState } from "react";

interface Props {
  product: ProductDetails;
}

const AskQuestionForm = ({ product }: Props) => {
  const [question, setQuestion] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.auth.user);
  const [name, setName] = useState<string>("");

  const handleSubmit = () => {
    if (!!!user?.firstName && name === "") {
      toastMe("Please enter your name!", "warning");
      return;
    }

    setLoading(true);

    const questionData: any = {};

    questionData.product_id = product.id;
    questionData.email = user?.email;
    questionData.content = question;
    questionData.first_name = name;

    createQuestion(questionData)
      .then((response) => {
        // dispatch(setIsUserReviewed({ [product.id]: true }));

        toastMe(
          "Successfully published your question, Please wait for answer",
          "success"
        );
      })
      .catch((error) => {
        toastMe("Something went wrong!", "error");
      })
      .finally(() => {
        setLoading(false);
        dispatch(setGlobalPopupElement(null));
      });
  };

  return (
    <div className="bg-white p-8 rounded-md md:min-w-[30vw] md:max-w-[80vw] max-h-[80vh] overflow-y-scroll scrollbar-ui">
      <div className="overflow-hidden">
        <div className="mb-4 flex gap-2 items-start">
          <div>
            <p className="font-semibold">Ask Your Question</p>
            {/* <p>{product.name}</p> */}
          </div>
        </div>

        <div>
          <div className="mb-4">
            <p className="font-semibold">Product</p>
            <p>{product?.name}</p>
          </div>
          {!!!user?.firstName && (
            <div className="flex flex-col">
              <label htmlFor="name" className="text-lg font-semibold">
                Name
              </label>
              <input
                className="w-full bg-backgournd-card rounded-[5px] py-3 px-4 text-sm text-gray3"
                id="name"
                type="text"
                placeholder="Your Name"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
          )}
          <div>
            <label htmlFor="images" className="font-semibold">
              Question
            </label>{" "}
            <br />
            <textarea
              name="review"
              id="review"
              cols={10}
              rows={5}
              className="border rounded w-full p-2 my-2"
              onChange={(e) => setQuestion(e.target.value)}
              required
            ></textarea>
          </div>
          <button
            className="bg-primary text-white px-4 py-2 rounded-md font-medium disabled:opacity-40 flex items-center gap-2"
            onClick={handleSubmit}
            disabled={loading}
          >
            SUBMIT
            {loading && (
              <span className="block border-gray-300 h-5 w-5 animate-spin rounded-full border-2 border-t-blue-600" />
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AskQuestionForm;
